export default class CustomFieldRequestDTO {
    fieldName: string;
    value: string;
    id?: number;

    constructor(fieldName: string, value: string, id?: number) {
        this.fieldName = fieldName;
        this.value = value;
        this.id = id;
    }

    public static fromJson(json: any): CustomFieldRequestDTO {
        return new CustomFieldRequestDTO(json.fieldName, json.value, json.id);
    }

    /**
     * Extracts and returns custom fields of the given product or undefined if there're none
     * @param product product from the {@link ProductSelectionForm}
     */
    public static getCustomFieldsForRequest(product?: any): CustomFieldRequestDTO[] {
        if (!product) return [];

        const customFields = product.customFields;
        if (customFields && Array.isArray(customFields) && customFields.length > 0)
            return customFields.map(customField => new CustomFieldRequestDTO(customField.fieldName, customField.value));

        return [];
    }
}
